import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class ToggleGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly featureFlagService: TranslationService) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const enableStatus = this.featureFlagService.featureFlags;
    const page = route.data['page'];
    if (enableStatus.general[page]) {
      return true;
    } else {
      this.router.navigateByUrl('coming-soon');
      return false;
    }
  }
}
